var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('navigation-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.initialized,
      expression: "initialized"
    }]
  }, _vm._l(_vm.visibleMenuList, function (v, i) {
    return _c(v.disabled ? 'div' : 'router-link', {
      key: i,
      tag: "component",
      staticClass: "tab-item",
      class: {
        disabled: v.disabled
      },
      attrs: {
        "to": !v.disabled ? {
          name: v.pathName
        } : undefined
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(v.name)) + " "), v.tooltip && v.tooltip.enabled ? _c('info-tooltip', {
      staticClass: "ml-2",
      attrs: {
        "position": "bottom",
        "content": v.tooltip.content
      }
    }) : _vm._e()], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }